var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionShowCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 34,
    viewBox: "0 0 128 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 33,
    x: -0.5,
    y: -0.5,
    fill: "#FFF",
    stroke: "#0078D4",
    rx: 0.592
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#0078D7",
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 0.45
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 21
  }, "Add a Comment")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionShowCard);
export default __webpack_public_path__ + "static/media/actionShowCard.60f7827cbaedbd400f389cef26c8887e.svg";
export { ForwardRef as ReactComponent };